import { formatMoney } from "@/neon/currency";
import { getSizedImageUrl, imageSize } from "@/lib/images";
import { renderUnitPrice } from "@/lib/product";

const plus = `<svg width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 0v11M0 5.5h11" stroke="currentColor"/></svg>`;
const minus = `<svg width="10" height="2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1h8" stroke="currentColor" stroke-linecap="square"/></svg>`;

const renderLineDiscounts = discounts => {
  if (Boolean(discounts.length)) {
    const formatted_discounts = discounts.map(
      ({ amount, discount_application: { title } }) => {
        return `<li>${title} (-${formatMoney(amount)})</li>`;
      }
    );

    return `
      <ul class="quick-cart__item-discounts">
        ${formatted_discounts}
      </ul>
    `;
  } else {
    return "";
  }
};

export function createItem(
  {
    variant_id: id,
    product_title: title,
    original_line_price: original_price,
    price,
    variant_title: color,
    line_level_discount_allocations: line_discounts,
    options_with_values,
    product_has_only_default_variant,
    image,
    url,
    quantity,
    unit_price,
    unit_price_measurement,
    selling_plan_allocation,
    ...item
  },
  highlightProduct
) {
  const img =
    image &&
    getSizedImageUrl(image.replace("." + imageSize(image), ""), "200x");

  let priceQuanity = "";

  if (quantity > 1) {
    priceQuanity = `x ${quantity}`;
  }

  let productOptions = ``;

  const quantityZeroLeading = quantity > 9 ? quantity : `0${quantity}`;

  if (!product_has_only_default_variant) {
    options_with_values.forEach(option => {
      const optionItem = `
        <div>
          ${option.name}: ${option.value}
        </div>
      `;

      productOptions += optionItem;
    });
  }

  const sellingPlanName = selling_plan_allocation
    ? `<p class="type-body-regular mt0 mb0">${selling_plan_allocation.selling_plan.name}</p>`
    : ``;

  return /*html*/ `
    <div class='cart__item${
      highlightProduct ? " cart__item--highlight" : ""
    }' data-component='quickCartItem' data-id=${id}>
      <div class="cart__item-content">
        <div class='quick-cart__image'>
        ${
          img
            ? `
              <a href='${url}'>
                <img src='${img}' alt='${title}' />
              </a>
            `
            : `<div class="placeholder"></div>`
        }
        </div>
        <div class='quick-cart__product-details justify-between'>
          <div>
            <h4 class="ma0">
              <a href='${url}'>${title}</a>
            </h4>
            <span class="quick-cart__product-price">
              <span class="quick-cart__product-price-value">
                ${formatMoney(price)} <span>${priceQuanity}</span>
              </span>
              ${renderUnitPrice(unit_price, unit_price_measurement)}
              ${renderLineDiscounts(line_discounts)}
              ${sellingPlanName}
            </span>
            ${productOptions}
          </div>
        </div>
      </div>

      <div class='quick-cart__item-bottom'>
        <div class='quick-cart__quantity'>
          <button type="button" class='quick-cart__quantity-button js-remove-single px05'>${minus}</button>
          <div class='quick-cart__item-total js-single-quantity'>${quantityZeroLeading}</div>
          <button type="button" class='quick-cart__quantity-button js-add-single px05'>${plus}</button>
        </div>
      </div>
    </div>
  `;
}

export function createRecent({
  handle,
  title,
  url,
  featured_image: image,
  ...product
}) {
  const img =
    image &&
    getSizedImageUrl(image.replace("." + imageSize(image), ""), "200x");

  return /*html*/ `
    <div class="cart__item justify-around">
      <div class="cart__item-content">
        <div class="quick-cart__image">
          ${
            img
              ? `
              <a href='${url}'>
                <img src='${img}' />
              </a>
            `
              : `<div class="placeholder"></div>`
          }
        </div>
        <div class="quick-cart__product-details">
          <a href="${url}">
            <h3 class="ma0">${title}</h3>
          </a>
          <span class="quick-cart__product-price">${formatMoney(
            product.price
          )}</span>
        </div>
      </div>
    </div>
  `;
}
